import { TransportPrincipalType } from '@enums/transport.enum';
import { ApplymentMoment } from '@enums/additional.enum';

/**
 * Utilidades y reglas de dominio para transportes
 */
export class TransportHelper {
  /**
   * Determina si el tipo de transporte es elegible para gestión de cita previa con cliente final.
   */
  static isAppointmentPrincipalType(type: TransportPrincipalType | string | null | undefined): boolean {
    return type === TransportPrincipalType.DELIVERY_TO_FINAL_CUSTOMER ||
           type === TransportPrincipalType.PICKUP_TO_FINAL_CUSTOMER ||
           type === TransportPrincipalType.PICKUP_AND_DELIVERY_TO_FINAL_CUSTOMER;
  }

  /**
   * Determina si el tipo de transporte contempla cita en la fase de recogida.
   */
  static hasPickupAppointment(type: TransportPrincipalType | string | null | undefined): boolean {
    return type === TransportPrincipalType.PICKUP_TO_FINAL_CUSTOMER ||
           type === TransportPrincipalType.PICKUP_AND_DELIVERY_TO_FINAL_CUSTOMER;
  }

  /**
   * Determina si el tipo de transporte contempla cita en la fase de entrega.
   */
  static hasDeliveryAppointment(type: TransportPrincipalType | string | null | undefined): boolean {
    return type === TransportPrincipalType.DELIVERY_TO_FINAL_CUSTOMER ||
           type === TransportPrincipalType.PICKUP_AND_DELIVERY_TO_FINAL_CUSTOMER;
  }

  /**
   * Determina si un servicio adicional de cita es específico de recogida.
   */
  static isSpecificServiceForPickup(service: { applyment_moment?: string }): boolean {
    return service.applyment_moment === ApplymentMoment.PICKUP;
  }

  /**
   * Determina si un servicio adicional de cita es específico de entrega.
   */
  static isSpecificServiceForDelivery(service: { applyment_moment?: string }): boolean {
    return service.applyment_moment === ApplymentMoment.DROPOFF;
  }

  /**
   * Determina si un servicio adicional de cita es combinado (ambas fases).
   */
  static isServiceCombined(service: { applyment_moment?: string }): boolean {
    const m = service.applyment_moment;
    return m === ApplymentMoment.PICKUP_AND_DROPOFF || m === ApplymentMoment.ALL;
  }

  /**
   * Determina si un servicio adicional de cita es compatible con la recogida.
   */
  static isServiceForPickup(service: { applyment_moment?: string }): boolean {
    const m = service.applyment_moment;
    return m === ApplymentMoment.PICKUP || 
           m === ApplymentMoment.PICKUP_AND_DROPOFF || 
           m === ApplymentMoment.ALL;
  }

  /**
   * Determina si un servicio adicional de cita es compatible con la entrega.
   */
  static isServiceForDelivery(service: { applyment_moment?: string }): boolean {
    const m = service.applyment_moment;
    return m === ApplymentMoment.DROPOFF || 
           m === ApplymentMoment.PICKUP_AND_DROPOFF || 
           m === ApplymentMoment.ALL;
  }
}
